export const CONSENT_KEY = "peak_signup_cookie_prefs";
export const CONSENT_EVENT = "peak_signup_cookie_prefs_changed";

export interface CookiePrefs {
  essential: true;
  analytics: boolean;
  marketing: boolean;
}

export function readCookiePrefs(): CookiePrefs | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookiePrefs>;
    if (typeof parsed.analytics !== "boolean") return null;
    if (typeof parsed.marketing !== "boolean") return null;
    return { essential: true, analytics: parsed.analytics, marketing: parsed.marketing };
  } catch {
    return null;
  }
}

export function readAnalyticsConsent(): boolean {
  return readCookiePrefs()?.analytics === true;
}

export function readMarketingConsent(): boolean {
  return readCookiePrefs()?.marketing === true;
}

export function publishCookiePrefs(prefs: CookiePrefs) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(prefs));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: prefs }));
}
